import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { BiCoinStack } from 'react-icons/bi';
import { MdOutlineCloudUpload } from 'react-icons/md'; // Cloud-Based Model Deployment
import { MdOutlineDevices } from 'react-icons/md';
import img1 from '../../../assets/img/Industries/Pharmaceuticals/4.jpg';

import { MdOutlineSpaceDashboard } from "react-icons/md";
import { CiCircleCheck } from "react-icons/ci";
import { FaChartLine, FaFlask, FaDatabase } from 'react-icons/fa'; // New icons for the features

export default function MainSection4() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Advanced Analytics for Patient Outcomes and Drug Efficacy
            </h1>
            <p className="text-lg text-gray-600">
              Deploy advanced analytics to track patient outcomes in real-time, providing actionable insights for healthcare providers and researchers.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaChartLine className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Outcome Monitoring
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Deploy advanced analytics to track patient outcomes in real-time, providing actionable insights for healthcare providers and researchers.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaFlask className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Drug Efficacy Optimization</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Analyze post-market surveillance data to assess drug performance and identify areas for improvement, ensuring maximum therapeutic impact.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaDatabase className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Centralized Data Lakes
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Consolidate patient data from various sources into centralized, secure repositories for in-depth analysis and predictive modeling.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}